import React, { useCallback, useEffect, useState } from 'react';
import { Pagination } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import PaginationItem from './PaginationItem';
const getSearchQuery = function () {
  let initialQuery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let pageQuery = arguments.length > 1 ? arguments[1] : undefined;
  let pageNumber = arguments.length > 2 ? arguments[2] : undefined;
  return '?' + initialQuery + '&' + pageQuery + '=' + pageNumber;
};
const PaginationMain = _ref => {
  let {
    initialQuery = '',
    pageQuery = 'page',
    totalPages = null,
    clearQueryOnDismount = true
  } = _ref;
  const {
    search
  } = useLocation();
  const history = useHistory();
  const [pageButtonItems, setPageButtonItems] = useState([]);
  const setPageNumberAndScrollToTop = useCallback(pageNumber => {
    window.scrollTo(0, 0);
    history.push({
      search: getSearchQuery(initialQuery, pageQuery, pageNumber)
    });
  }, [history, initialQuery, pageQuery]);
  useEffect(() => {
    if (totalPages) {
      const currentPage = new URLSearchParams(search).get('page');
      const items = Array.from({
        length: totalPages
      }, (_, index) => {
        const number = index + 1;
        return /*#__PURE__*/React.createElement(PaginationItem, {
          key: number,
          number: number,
          isActive: number === parseInt(currentPage),
          onClick: () => setPageNumberAndScrollToTop(number)
        });
      });
      setPageButtonItems(items);
    }
  }, [totalPages, setPageNumberAndScrollToTop, search]);
  useEffect(() => {
    history.push({
      search: getSearchQuery(initialQuery, pageQuery, 1)
    });
    return () => {
      if (clearQueryOnDismount) {
        history.push({
          search: ''
        });
      }
    };
  }, [history, initialQuery, pageQuery, clearQueryOnDismount]);
  return /*#__PURE__*/React.createElement(Pagination, {
    className: "justify-content-end"
  }, pageButtonItems);
};
export default PaginationMain;